import React, { useEffect, useState } from "react";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import cardClasses from "../../common/Cards/cardStyles.module.css";
import { DateTime } from "luxon";
import {
  collection,
  getDocs,
  onSnapshot,
  query,
  Timestamp,
  where,
} from "firebase/firestore";
import { db } from "../../scripts/app.js";

let now = DateTime.local().endOf("day");
let SevenDaysAgo = now.minus({ days: 7 }).startOf("day");
let lastSevenDays = [];
for (let i = 6; i >= 0; i--) {
  lastSevenDays.push(now.minus({ days: i }).startOf("day"));
}

const LaunchpadStats = () => {
  const [workflowChart, setWorkflowChart] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [taskChart, setTaskChart] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [userChart, setUserChart] = useState([0, 0, 0, 0, 0, 0, 0]);
  const [uniqueWorkflowIds, setUniqueWorkflowIds] = useState([]);
  const [uniqueUserIds, setUniqueUserIds] = useState([]);
  useEffect(() => {
    let ignore = false;

    // const now = DateTime.local();
    // const SevenDaysAgo = now.minus({ days: 7 }).startOf("day");

    setUniqueWorkflowIds([]);
    const queryDailyAggregates = query(
      collection(db, "dailyAggregates"),
      where("lastTaskStartedAt", ">=", Timestamp.fromMillis(SevenDaysAgo)),
      // where("lastTaskStartedAt", "<=", Timestamp.fromMillis(now))
    );
    const unsubscribe = onSnapshot(
      queryDailyAggregates,
      (queryDailyAggregatesSnapshot) => {
        console.log("Snapshot called change detected");
        now = DateTime.local().endOf("day");
        SevenDaysAgo = now.minus({ days: 7 }).startOf("day");
        lastSevenDays = [];
        for (let i = 6; i >= 0; i--) {
          lastSevenDays.push(now.minus({ days: i }).startOf("day"));
        }

        lastSevenDays.forEach((day, i) => {
          // queryDailyAggregatesSnapshot
          //   .docChanges()
          //   .forEach((change) => console.log("the logged change", change));

          queryDailyAggregatesSnapshot.forEach((doc) => {
            const workflowKeys = Object.keys(doc.data().workflows);
            setUniqueWorkflowIds((prevIds) => {
              console.log(
                "Snapshot called change detected doc.id",
                doc.id,
                "workflows in doc",
                workflowKeys,
                "prev workflows in set",
                prevIds
              );
              const uniqueSet = new Set(prevIds);
              workflowKeys.forEach((key) => uniqueSet.add(key));
              return Array.from(uniqueSet);
            });

            const aggregateDay = DateTime.fromSeconds(
              doc.data().lastTaskStartedAt.seconds
            );
            let tasks = 0;
            // console.log('DateTime when this doc was completed ->', aggregateDay, 'day in lastSevenDays ->', day, 'next day in lastSevenDays ->', lastSevenDays[i + 1], 'doc', doc.data())
            Object.values(doc.data().workflows).forEach((workflow) => {
              if (typeof Object.keys(workflow?.tasks).length === "number") {
                tasks += Object.keys(workflow?.tasks).length;
              }
            });
            if (i !== 6) {
              if (
                !ignore &&
                aggregateDay >= day &&
                aggregateDay < lastSevenDays[i + 1]
              ) {
                setWorkflowChart((chart) => {
                  let newChart = [...chart];
                  newChart[i] = workflowKeys.length;
                  return newChart;
                });
                setTaskChart((chart) => {
                  let newChart = [...chart];
                  newChart[i] = tasks;
                  return newChart;
                });
              }
            } else if (!ignore && aggregateDay >= day) {
              setWorkflowChart((chart) => {
                let newChart = [...chart];
                newChart[i] = workflowKeys.length;
                return newChart;
              });

              setTaskChart((chart) => {
                let newChart = [...chart];
                newChart[i] = tasks;
                return newChart;
              });
            }
          });
        });
      }
    );

    let unsub;
    async function getUserAggregates() {
      setUniqueUserIds([]);
      const queryUserAggregates = query(
        collection(db, "userAggregates"),
        where("date", ">=", Timestamp.fromMillis(SevenDaysAgo)),
        // where("date", "<=", Timestamp.fromMillis(now))
      );

      // const queryUserAggregatesSnapshot = await getDocs(queryUserAggregates);
      unsub = onSnapshot(queryUserAggregates, (queryUserAggregatesSnapshot) => {
      lastSevenDays.forEach((day, i) => {
        queryUserAggregatesSnapshot.forEach((doc) => {
          console.log('userAggregates', doc.data())
          const userKeys = Object.keys(doc.data().users);
          setUniqueUserIds((prevIds) => {
            const uniqueSet = new Set(prevIds);
            userKeys.forEach((key) => uniqueSet.add(key));
            return Array.from(uniqueSet);
          });
          const aggregateDay = DateTime.fromSeconds(doc.data().date.seconds);
          console.log('day of user doc', aggregateDay, 'day', day, 'lastSevenDays', lastSevenDays, 'lastSevenDays[i+1]', lastSevenDays[i+1])
          if (i !== 6) {
            if (
              !ignore &&
              aggregateDay >= day &&
              aggregateDay < lastSevenDays[i + 1]
            ) {
              setUserChart((chart) => {
                let newChart = [...chart];
                newChart[i] = Object.keys(doc.data().users).length;
                return newChart;
              });
            }
          } else if (!ignore && aggregateDay >= day) {
            setUserChart((chart) => {
              let newChart = [...chart];
              newChart[i] = Object.keys(doc.data().users).length;
              return newChart;
            });
          }
        });
      });
      })
    }

    // getDailyAggregates();
    getUserAggregates();
    return () => {
      ignore = true;
      unsubscribe();

    };
  }, []);

  // useEffect(() => {
  //   let ignore = false;

  //   // Reset state on mount
  //   setUniqueWorkflowIds([]);
  //   setUniqueUserIds([]);
  //   setWorkflowChart(Array(7).fill(0));
  //   setTaskChart(Array(7).fill(0));
  //   setUserChart(Array(7).fill(0));

  //   // ---- DAILY AGGREGATES LISTENER ----
  //   const queryDailyAggregates = query(
  //     collection(db, "dailyAggregates"),
  //     where("lastTaskStartedAt", ">=", Timestamp.fromMillis(SevenDaysAgo)),
  //     where("lastTaskStartedAt", "<=", Timestamp.fromMillis(now))
  //   );

  //   const unsubscribe = onSnapshot(queryDailyAggregates, (snapshot) => {
  //     if (ignore) return;
  //     console.log("Snapshot called change detected");

  //     // Prepare accumulators
  //     const newWorkflowChart = Array(7).fill(0);
  //     const newTaskChart = Array(7).fill(0);
  //     const newUniqueWorkflowIds = new Set();

  //     // Process all docs in the snapshot
  //     snapshot.forEach((doc) => {
  //       const data = doc.data();
  //       const workflowKeys = Object.keys(data.workflows || {});
  //       workflowKeys.forEach((key) => newUniqueWorkflowIds.add(key));

  //       const aggregateDay = DateTime.fromSeconds(data.lastTaskStartedAt.seconds);
  //       let totalTasks = 0;

  //       Object.values(data.workflows).forEach((workflow) => {
  //         if (workflow?.tasks) {
  //           totalTasks += Object.keys(workflow.tasks).length;
  //         }
  //       });

  //       // Place this doc’s data into the correct day bucket
  //       lastSevenDays.forEach((day, i) => {
  //         const nextDay = lastSevenDays[i + 1];
  //         const inRange =
  //           (i !== 6 && aggregateDay > day && aggregateDay < nextDay) ||
  //           (i === 6 && aggregateDay > day);

  //         if (inRange) {
  //           newWorkflowChart[i] += workflowKeys.length;
  //           newTaskChart[i] += totalTasks;
  //         }
  //       });
  //     });

  //     // Update state once per snapshot
  //     setWorkflowChart(newWorkflowChart);
  //     setTaskChart(newTaskChart);
  //     setUniqueWorkflowIds(Array.from(newUniqueWorkflowIds));
  //   });

  //   // ---- USER AGGREGATES FETCH ----
  //   async function getUserAggregates() {
  //     if (ignore) return;

  //     const queryUserAggregates = query(
  //       collection(db, "userAggregates"),
  //       where("date", ">=", Timestamp.fromMillis(SevenDaysAgo)),
  //       where("date", "<=", Timestamp.fromMillis(now))
  //     );

  //     const snapshot = await getDocs(queryUserAggregates);

  //     const newUserChart = Array(7).fill(0);
  //     const newUniqueUserIds = new Set();

  //     snapshot.forEach((doc) => {
  //       const data = doc.data();
  //       const userKeys = Object.keys(data.users || {});
  //       userKeys.forEach((key) => newUniqueUserIds.add(key));

  //       const aggregateDay = DateTime.fromSeconds(data.date.seconds);

  //       lastSevenDays.forEach((day, i) => {
  //         const nextDay = lastSevenDays[i + 1];
  //         const inRange =
  //           (i !== 6 && aggregateDay > day && aggregateDay < nextDay) ||
  //           (i === 6 && aggregateDay > day);

  //         if (inRange) {
  //           newUserChart[i] += userKeys.length;
  //         }
  //       });
  //     });

  //     // Single batch update
  //     setUserChart(newUserChart);
  //     setUniqueUserIds(Array.from(newUniqueUserIds));
  //   }

  //   getUserAggregates();

  //   // Cleanup
  //   return () => {
  //     ignore = true;
  //     unsubscribe();
  //   };
  // }, []);

  return (
    <>
      <div className="px-4">
        <h4 className="mb-4 bg-gray-200 rounded-2xl size-auto py-2 px-4 border-gray-300 border-[1px]">
          TODAY
        </h4>
      </div>
      <ul className={`${cardClasses.cards} ${cardClasses.aggregateCards}`}>
        <li
          className={`${cardClasses.card} ${cardClasses.aggregateCard} ${cardClasses.mini}  border-[#0A9D03]`}
        >
          <div className={cardClasses.upper}>
            <h2>Active Users</h2>
            <div className="flex-wrapper stats-area">
              <div className={`${cardClasses.stat} text-[#0A9D03]`}>
                {userChart[6]}
              </div>
            </div>
          </div>
        </li>
        <li
          className={`${cardClasses.card} ${cardClasses.aggregateCard} ${cardClasses.mini}  border-[#0A9D03]`}
        >
          <div className={cardClasses.upper}>
            <h2>TASKS COMPLETED</h2>
            <div className="flex-wrapper stats-area">
              <div className={`${cardClasses.stat} text-[#0A9D03]`}>
                {taskChart[6]}
              </div>
            </div>
          </div>
        </li>
        <li
          className={`${cardClasses.card} ${cardClasses.aggregateCard} ${cardClasses.mini}  border-[#0A9D03]`}
        >
          <div className={cardClasses.upper}>
            <h2>Workflows Used</h2>
            <div className="flex-wrapper stats-area">
              <div className={`${cardClasses.stat} text-[#0A9D03]`}>
                {workflowChart[6]}
              </div>
            </div>
          </div>
        </li>
      </ul>

      <div className="px-4">
        <h4 className="mb-4 bg-gray-200 rounded-2xl size-auto py-2 px-4 border-gray-300 border-[1px]">
          LAST 7 DAYS
        </h4>
      </div>

      <ul className={`${cardClasses.cards} ${cardClasses.aggregateCards}`}>
        <li
          className={`${cardClasses.card} ${cardClasses.aggregateCard} ${cardClasses.mini}`}
        >
          <div className={cardClasses.upper}>
            <h2>Active Users</h2>
            <div className={cardClasses.statsArea}>
              <div>
                <div className={cardClasses.stat}>
                  {uniqueUserIds.length}
                  {/* <span className={cardClasses.ofStat}></span> */}
                </div>
              </div>
              <SparkLineChart
                data={userChart}
                // plotType="bar"
                xAxis={{
                  // scaleType: "band",
                  scaleType: "time",
                  data: lastSevenDays,
                  valueFormatter: (value) => value.toISODate(),
                }}
                height={50}
                showHighlight={true}
                showTooltip={true}
                color="#8150e3"
              />
            </div>
          </div>
        </li>
        <li
          className={`${cardClasses.card} ${cardClasses.aggregateCard} ${cardClasses.mini}`}
        >
          <div className={cardClasses.upper}>
            <h2>TASKS COMPLETED</h2>
            <div className={cardClasses.statsArea}>
              <div>
                <div className={cardClasses.stat}>
                  {taskChart.reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                  )}
                  {/* <span className={cardClasses.ofStat}></span> */}
                </div>
              </div>
              <SparkLineChart
                data={taskChart}
                // plotType="bar"
                xAxis={{
                  // scaleType: "band",
                  scaleType: "time",
                  data: lastSevenDays,
                  valueFormatter: (value) => value.toISODate(),
                }}
                height={50}
                showHighlight={true}
                showTooltip={true}
                color="#8150e3"
              />
            </div>
          </div>
        </li>
        <li
          className={`${cardClasses.card} ${cardClasses.aggregateCard} ${cardClasses.mini}`}
        >
          <div className={cardClasses.upper}>
            <h2>Workflows Used</h2>
            <div className={cardClasses.statsArea}>
              <div>
                <div className={cardClasses.stat}>
                  {uniqueWorkflowIds.length}
                  {/* <span className={cardClasses.ofStat}></span> */}
                </div>
              </div>
              <SparkLineChart
                data={workflowChart}
                // plotType="bar"
                xAxis={{
                  // scaleType: "band",
                  scaleType: "time",
                  data: lastSevenDays,
                  valueFormatter: (value) => value.toISODate(),
                }}
                height={50}
                showHighlight={true}
                showTooltip={true}
                color="#8150e3"
              />
            </div>
          </div>
        </li>
      </ul>
    </>
  );
};

export default LaunchpadStats;
